$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';

import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

import 'jquery-nice-select/js/jquery.nice-select.min.js';

gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- NAV ---
    
    $(".nav-search").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-search-modal .search-close").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-responsive").removeClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $(".burger").removeClass("active")
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-modal .cart-close").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-burger, .nav-responsive-overlay").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $(".nav-responsive-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport"); 
    });
    $(".nav-cart-overlay").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    
    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-responsive ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        }
    });
    
    $(".page-single article .gallery br").remove();

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    // --- WORDPRESS FORM CONTROL ---
    
    $(".widget_archive select").addClass("form-control");
    $(".widget_categories select").addClass("form-control");
    $(".woocommerce-account .woocommerce").addClass("row justify-content-between");
    
    // --- WOOCOMMERCE ---

    $(document).on('click', '.product-quantity-minus', function(e) {
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        var newQuantity = (currentQuantity >= 1) ? (currentQuantity - 1) : 0;
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(document).on('click', '.product-quantity-plus', function(e) {
        var max_quantity = 99999;
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        if(isNaN(currentQuantity)) currentQuantity = 0;
        var newQuantity = (currentQuantity >= max_quantity) ? max_quantity : (currentQuantity + 1);
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });
    
    
    $(document.body).trigger('wc_fragment_refresh');
    
    
    $('.form-select').niceSelect();
    

});


// === SHOW/HIDE NAV ===

const showhideNav = gsap.from('.nav-sticky', {
    // opacity: 0,
    // yPercent: -100,
    paused: true,
    duration: 0.5,
}).progress(1);

ScrollTrigger.create({
    start: 'top top',
    end: 99999,
    onUpdate: (self) => {
        const navSticky = document.querySelector('.nav-sticky');
        if (self.direction === -1) {
            showhideNav.play();
            navSticky.classList.add('has-bg');
        } else {
            showhideNav.reverse();
            navSticky.classList.add('has-scrolled');
        }

        const minScrollTop = document.body.classList.contains('admin-bar') ? 32 : 0;
        if (window.scrollY <= minScrollTop) {
            navSticky.classList.remove('has-scrolled');
            navSticky.classList.remove('has-bg');
        }
    },
});


// === SWIPER ===

var swiper = new Swiper(".product-swiper", {
    effect: "cards",
    grabCursor: true,
    navigation: {
        nextEl: ".product-swiper .swiper-next",
        prevEl: ".product-swiper .swiper-prev",
    },
});


// === MASONRY ===

const grid = document.querySelector('.masonry');
imagesLoaded(grid, function() {
    const msnry = new Masonry(grid, {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-sizer',
        percentPosition: true,
        horizontalOrder: true
    });
});